import { Link } from 'react-router-dom'

export function NotFoundPage() {
  return (
    <div className="mx-auto max-w-md px-lg py-2xl text-center">
      <h1>404</h1>
      <p className="mt-sm text-text-muted">No encontramos esa página.</p>
      <Link to="/" className="btn-primary mt-lg inline-block no-underline">
        Volver al inicio
      </Link>
    </div>
  )
}
